import React from "react";
import { Box, Typography, TypographyProps } from "@mui/material";

export default function RpFieldLabel({
  children,
  required = false,
  variant = "caption",
  fontWeight = 600,
  color = "text.primary",
  mb = 0.25,
  ...rest
}: TypographyProps & {
  required?: boolean;
}) {
  return (
    <Typography
      variant={variant}
      fontWeight={fontWeight}
      color={color}
      display="block"
      mb={mb}
      {...rest}
    >
      {children}
      {required && (
        <Box component="span" sx={{ color: "error.main", marginLeft: "2px" }}>
          *
        </Box>
      )}
    </Typography>
  );
}
